var CoveoFacetSelection = (function () {
    var config = {
        facetContainer: $(".facetFilter_mainContainer"),
        facetButtonContainer: $(".facetFilter_btnContainer"),
        coveoRootSelector: ".coveo-searchinterface .CoveoSearchInterface",
        coveoRoot: null,
        selectedFilterContainer: $(".selected_filter"),
        selectedFacets: [],
        facetSelectors: ".facetFilter_mainContainer .coveo-facet-values li",
        checkBoxSelector: "input[type='checkbox']",
        dataValueAttribute: "data-value",
        coveoSelectedClass: "coveo-selected",
        blankSpanHtml: '<span class="d-none">' +
            '<button tabindex="0" class="remove_selectedFilter" aria-label="clear">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">' +
            '<path d="M2.62477 1.38672L1.38733 2.62416L11.3747 12.6115L12.6121 11.3741L2.62477 1.38672Z" fill="#666666"/>' +
            '<path d="M11.3747 1.38672L1.38733 11.3741L2.62477 12.6115L12.6121 2.62416L11.3747 1.38672Z" fill="#666666"/>' +
            '</svg>' +
            '</button>' +
            '</span>',
        facetSpanHtml: '<span>[val]' +
            '<button tabindex="0" class="remove_selectedFilter" aria-label="clear" data-value="[val]">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">' +
            '<path d="M2.62477 1.38672L1.38733 2.62416L11.3747 12.6115L12.6121 11.3741L2.62477 1.38672Z" fill="#666666"/>' +
            '<path d="M11.3747 1.38672L1.38733 11.3741L2.62477 12.6115L12.6121 2.62416L11.3747 1.38672Z" fill="#666666"/>' +
            '</svg>' +
            '</button></span>',
        removeButtonSelector: ".remove_selectedFilter",
        facetHeaderSelector: $(".facetFilter_btn"),
        facetExpandedClass: "facetFilter_expanded",
        facetFilterBorderClass: "facetFilter_border",
        mainFilterContainer: $(".facetFilter_mainContainer"),
        resizeTimeout: null,
    };

    //constructor
    function CoveoFacetSelection() {
        // intentionaly kept empty
    }

    CoveoFacetSelection.prototype.init = function () {
        var self = this;

        //set coveo root
        config.coveoRoot = Coveo.$$(document).find(config.coveoRootSelector);

        //bind events
        self.bindEvents();

        config.facetHeaderSelector.attr("aria-expanded", false);
    };

    CoveoFacetSelection.prototype.bindEvents = function () {
        var self = this;

        //Coveo Query success event
        Coveo.$$(config.coveoRoot).on("querySuccess", function (e, args) {
            self.populateFacetSelection();
        });

        //accodrion click event
        config.facetHeaderSelector.on("click", function () {
            self.toggleAccordion();
        });

        //resize event
        $(window).on("resize", function () {
            //clear timeout
            clearTimeout(config.resizeTimeout);

            //set timeout
            config.resizeTimeout = setTimeout(function () {
                if ($(window).width() > 991) {
                    config.mainFilterContainer.show();
                }
            }, 400);
        });
    };

    CoveoFacetSelection.prototype.populateFacetSelection = function () {
        var self = this;

        //clear existing filters
        config.selectedFilterContainer.empty();
        config.selectedFacets.length = 0;

        config.selectedFilterContainer.append(config.blankSpanHtml);

        //get selected facets
        $(config.facetSelectors).each(function () {
            var facet = $(this);

            if (facet.hasClass(config.coveoSelectedClass)) {
                var facetValue = facet.attr(config.dataValueAttribute);
                config.selectedFacets.push({
                    value: facetValue,
                    checkBox: facet.find(config.checkBoxSelector)
                });
                config.selectedFilterContainer.append(config.facetSpanHtml.replace(/\[val\]/g, facetValue));
            }
        });

        //bind remove click event
        $(config.removeButtonSelector).on("click", function () {
            self.handleRemoveFacet($(this).attr(config.dataValueAttribute));
        });
    };

    CoveoFacetSelection.prototype.toggleAccordion = function () {
        config.facetContainer.slideToggle();
        config.facetButtonContainer.toggleClass(config.facetExpandedClass);
        config.facetButtonContainer.parent().toggleClass(config.facetFilterBorderClass);
        config.facetHeaderSelector.attr("aria-expanded", config.facetButtonContainer.hasClass(config.facetExpandedClass));
    };

    CoveoFacetSelection.prototype.handleRemoveFacet = function (val) {
        var selectedFacets = config.selectedFacets;

        //get the specific facet and trigger click
        selectedFacets.forEach(function (facet) {
            if (facet.value === val) {
                facet.checkBox[0].click();
                return false; // Break out of the loop
            }
        });
    };

    return CoveoFacetSelection;
})();

$(document).ready(function () {
    if ($(".facetFilter_mainContainer").length > 0) {
        new CoveoFacetSelection().init();
    }
});